<template>
  <v-card >
    <v-toolbar dense flat dark color="primary" class="mb-20">
      <v-toolbar-title class="body-2">{{ formTitle }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
      <v-btn x-small icon @click="$emit('close')">
        <v-icon>fa fa-close</v-icon>
      </v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row >
          <v-col cols="12" class="py-1">
            <v-tabs v-model="tab" dense class="suscripcion" >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab >Datos Generales</v-tab>
                  <v-tab>CategorÍas</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab" touchless>
                  <v-tab-item>
                    <v-row class="">
                      <v-col cols=12 class="font-weight-normal caption">Fecha alta: {{editedItem.fecha_insert | DDMMAAAA_HHMM}}</v-col>
                    </v-row>
                    <v-row class="">
                      <v-col cols=12 class="font-weight-normal"><v-avatar color="secondary" size="24" class="white--text font-weight-bold mr-5">1</v-avatar>DATOS PERSONALES</v-col>
                    </v-row>
                    <v-row class="">
                      <v-col cols:=12 md=4>
                        <v-text-field 
                          :error-messages="nombreErrors"
                          required
                          v-model="frm.nombre"
                          @input="$v.frm.nombre.$touch()"
                          @blur="$v.frm.nombre.$touch()"
                          dense label="Nombre" color="primary" 
                          hide-details
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=4>
                        <v-text-field 
                          :error-messages="apellidoErrors"
                          hide-details
                          required
                          v-model="frm.apellido"
                          @input="$v.frm.apellido.$touch()"
                          @blur="$v.frm.apellido.$touch()"
                          dense label="Apellido" color="primary"></v-text-field>
                        </v-col>
                      <v-col cols=12 md=4>
                        <v-text-field dense label="E-mail" color="primary" 
                          :error-messages="emailErrors"
                          hide-details
                          required
                          v-model="frm.email"
                          @input="$v.frm.email.$touch()"
                          @blur="$v.frm.email.$touch()"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=4>
                        <v-text-field dense label="Celular" color="primary"
                          :error-messages="celularErrors"
                          hide-details
                          required
                          v-model="frm.celular"
                          @input="$v.frm.celular.$touch()"
                          @blur="$v.frm.celular.$touch()"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=4>
                        <v-select
                          v-model="frm.tipoUsr"
                          hide-details
                          :items="tiposUsr"
                          color="primary"
                          dense 
                          label="Tipo de Usuario" 
                          return-object

                          :error-messages="tipoUsrErrors"
                          required
                          @input="$v.frm.tipoUsr.$touch()"
                          @blur="$v.frm.tipoUsr.$touch()"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols=12 md=4 class="hidde-sm-and-down">
                        <v-spacer></v-spacer>
                      </v-col>
                      <v-col cols=12 md=4 >
                        <v-select
                          v-model="frm.referencia"
                          hide-details
                          :items="referencias"
                          color="primary"
                          dense 
                          label="Dónde nos conociste?" 
                          return-object
                        >
                        </v-select>
                      </v-col>
                    </v-row>
                    <v-row  class="py-0">
                      <v-col cols=12 class="font-weight-normal "><v-avatar color="secondary" size="24" class="white--text font-weight-bold mr-5">2</v-avatar>DATOS DE EMPRESA</v-col>
                    </v-row>
                    <v-row class="py-0">
                      <v-col cols=12 md=5>
                        <v-text-field dense label="Razón Social" color="primary"
                          v-model="frm.razonSoc"
                          hide-details
                          :error-messages="razonSocErrors"
                          required
                          @input="$v.frm.razonSoc.$touch()"
                          @blur="$v.frm.razonSoc.$touch()"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=5>
                        <v-text-field dense label="Teléfono" color="primary"
                          v-model="frm.tel"
                          hide-details
                          :error-messages="telErrors"
                          required
                          @input="$v.frm.tel.$touch()"
                          @blur="$v.frm.tel.$touch()" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=5>
                        <v-text-field dense label="Dirección" color="primary"
                          v-model="frm.dir"
                          hide-details
                          :error-messages="dirErrors"
                          required
                          @input="$v.frm.dir.$touch()"
                          @blur="$v.frm.dir.$touch()" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=3>
                        <v-select
                          :items="provincias"
                          return-object
                          hide-details
                          dense label="Provincia" color="primary"
                          v-model="frm.provincia"
                          :error-messages="provinciaErrors"
                          required
                          @change="$v.frm.provincia.$touch()"
                          @blur="$v.frm.provincia.$touch()"  
                         :menu-props="{auto: true, overflowY: true ,maxHeight:150}"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols=12 md=4>
                        <v-text-field dense label="Localidad" color="primary"
                          v-model="frm.localidad"
                          hide-details
                          :error-messages="localidadErrors"
                          required
                          @input="$v.frm.localidad.$touch()"
                          @blur="$v.frm.localidad.$touch()" 
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=3 >
                        <v-text-field dense label="Cod. Postal" color="primary"
                          v-model="frm.cp"
                          hide-details
                          :error-messages="cpErrors"
                          required
                          @input="$v.frm.cp.$touch()"
                          @blur="$v.frm.cp.$touch()"  
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 md=9 class="hidde-sm-and-down">
                        <v-spacer></v-spacer>
                      </v-col>
                    </v-row>
                    <v-row class="py-0">
                      <v-col cols=12 md=5>
                        <v-select
                          v-model="frm.tEmpresa"
                          hide-details
                          :menu-props="{ top: true, offsetY: false }"
                          :items="tiposEmpresas"
                          color="primary"
                          dense 
                          attach
                          small-chips
                          placeholder="Tipo de Empresa" 
                          multiple
                          deletable-chips
                          return-object
                          :error-messages="tEmpresaErrors"
                          required
                          @change="$v.frm.tEmpresa.$touch()"
                          @blur="$v.frm.tEmpresa.$touch()" 

                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-text-field dense hide-details v-model="frm.TEmpresa_Otro" placeholder="Otro tipo" color="primary" :disabled="!frm.tEmpresa.filter( item => item.value==6).length==1">
                        </v-text-field>
                      </v-col>
                    </v-row>
                  </v-tab-item>
                  <v-tab-item>
                    <v-row >
                      <v-col cols=12><v-avatar color="secondary" size="24" class="white--text font-weight-bold mr-5">1</v-avatar>CATEGORÍA/SUBCATEGORÍA</v-col>
                      <v-col cols=12 sm=5 >
                        <v-select
                          v-model="categorie"
                          :items="categories"
                          item-text="categoria"
                          color="primary"
                          dense 
                          label="Categoría" 
                          clearable
                          return-object

                          @click:clear="categorie={}"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols=12 sm=5>
                        <v-select
                          v-model="subCategorie"
                          :items="subCategories"
                          item-text="subCategoria"
                          color="primary"
                          dense 
                          label="Sub Categoría" 
                          clearable
                          return-object

                          @click.clear="subCategorie={}"

                        >
                      </v-select>
                      </v-col>
                      <v-col cols=12 sm=1 class="pt-0 pt-sm-2">
                        <v-btn 
                          fab
                          small 
                          color="secondary"
                          class="white--text mx-0" 
                          @click="addCategories"

                          :disabled="!( countCategories< maxCategories && (categorie && Object.keys(categorie).length !== 0)   )"
                        >
                          <v-icon small >fa-plus</v-icon>
                        </v-btn>
                        
                      </v-col>
                    </v-row>
                    <v-row cols=12 no-gutters="">
                      <v-card tile  elevation=0 width="100%" class="pa-0 " min-height="80px" color="#ddd" > 
                        <v-list dense class="pa-0 ma-0" color="#ddd" >
                          <template v-for="(item, i) in frm.categories">
                          <v-list-item  :key="i" >
                            <v-list-item-content >
                              <v-list-item-title class="body-2">
                                <v-breadcrumbs class="ma-0 pa-0 caption" :items="[{text:item.categoria},{text:item.subCategoria}]"></v-breadcrumbs>
                              </v-list-item-title>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-icon color="primary" @click="removeCategories(item,i)">fa-close</v-icon>
                            </v-list-item-icon>
                          </v-list-item>
                          <v-divider :key="`divider_${i}`"></v-divider>
                          </template>
                        </v-list>
                      </v-card>
                      <div class="v-text-field__details">
                        <div class="v-messages theme--light error--text">
                          <div class="v-messages__wrapper">
                            <div class="v-messages__message">{{categoriesErrors}}</div>
                          </div>
                        </div>
                        <div class="v-counter theme--light">{{countCategories}} / {{maxCategories}}</div>
                      </div>
                    </v-row>
                  
                    <v-row>
                      <v-col cols=12 class="mt-5">
                        <v-avatar color="secondary" size="24" class="white--text font-weight-bold mr-5">2</v-avatar>PALABRAS CLAVES
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols=12 sm=5>
                        <v-text-field 
                          dense 
                          v-model="txtKey" 
                          label="Palabras clave" 
                          color="primary"
                          counter
                          maxlength="100"
                          clearable
                          :error-messages="txtKeyErrors"
                        >
                        </v-text-field>
                      </v-col>
                      <v-col cols=12 sm=1 class="pt-0 pt-sm-2">
                        
                        <v-btn 
                          small
                          fab
                          rounded 
                          color="secondary" 
                          class="white--text " 
                          @click="addKeys" 
                          :disabled="!(countKeys< maxKeys && txtKey && txtKeyErrors.length==0)"
                          >
                          <v-icon small >fa-plus</v-icon> 
                          
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-row  no-gutters="">
                        <v-card tile  elevation=0 width="100%" class="pa-0 " min-height="80px" color="#ddd" > 
                            <v-chip v-for="(item, i) in frm.keys" :key="i" 
                              dense
                              close
                              class="ma-2 black--text" 
                              color="caption primary lighten1"
                              @click:close="removeKeys(item,i)"
                            >
                              {{item}}
                            </v-chip>
                        </v-card>
                        <div class="v-text-field__details">
                          <div class="v-messages theme--light error--text">
                            <div class="v-messages__wrapper">
                              <div class="v-messages__message">{{keysErrors}}</div>
                            </div>
                        </div>
                          <div class="v-counter theme--light">{{countKeys}} / {{maxKeys}}</div></div>
                    </v-row>
                    <!--
                      mdi-textbox
                    -->
                  </v-tab-item>
                </v-tabs-items>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
    <v-card-actions >
      <v-spacer></v-spacer>
      <v-btn color="primary darken-1" text @click.stop="$emit('close')">Cancelar</v-btn>
      <v-btn color="primary darken-1" text @click.stop.prevent="submit()" :loading="flgSave" >
        Aceptar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>



<script>

import {mapGetters} from 'vuex'

import { validationMixin } from 'vuelidate'
import { required, minLength, maxLength, email,numeric } from 'vuelidate/lib/validators'

import {format} from 'date-fns'

export default {

    name: 'PreInscripcion',

    components: {
    },

    props:['editedIndex','editedItem'],

    mixins: [validationMixin],

    validations: {

      frm: {
        nombre:{required,maxLength: maxLength(50),minLength:minLength(3)},  
        apellido:{required,maxLength: maxLength(50),minLength:minLength(3)},
        email: {required, email,maxLength: maxLength(80)},
        //celular:{required,maxLength: maxLength(25),minLength:minLength(6)},
        celular:{maxLength: maxLength(25)},
        tipoUsr:{required},
        //referencia:{required},

        razonSoc:{required,maxLength: maxLength(50),minLength:minLength(3)},
        tel:{required,maxLength: maxLength(18),minLength:minLength(6)},
        dir:{required,maxLength:maxLength(50),minLength:minLength(3)},
        localidad:{required,maxLength: maxLength(50),minLength:minLength(3)},
        provincia:{required},
        cp:{required,maxLength: maxLength(10),minLength:minLength(4)},
        tEmpresa:{required},
      } 
 

/*
      name: { required,// maxLength: maxLength(10) 
      },
      email: { required, email },
      select: { required },
      checkbox: {
        checked (val) {
          return val
        },
      },*/
    },

    data () {
      return {
        flgSave:false,

        seccion:"",
        tab:0,

        errors:false,

        categories:[],
        categorie:{},

        subCategories:[],
        subCategorie:{},
        maxCategories:5,
        
        txtKey:"",
        maxKeys:24,


        frm:{
          nombre:"",
          apellido:"",
          email:"",
          celular:"",
          tipoUsr:null,
          referencia:null,

          razonSoc:"",
          tel:"",
          dir:"",
          localidad:"",
          provincia:null,

          cp:"",
          tEmpresa:[],
          TEmpresa_Otro:"",

          categories:[],
          keys:[],
          completo:0
        },

        tiposEmpresas:[
          {value:1, text:"Distribuidor"},
          {value:2, text:"Exportador"},
          {value:3, text:"Importador"},
          {value:4, text:"Fabricante"},
          {value:5, text:"Proveedor de servicios"},
          {value:6, text:"Otro"},
        ],
        provincias:[
          {value:'C', text:'Ciudad Autónoma de Buenos Aires'},
          {value:'B', text:'Buenos Aires'},
          {value:'K', text:'Catamarca'},
          {value:'H', text:'Chaco'},
          {value:'U', text:'Chubut'},
          {value:'X', text:'Córdoba'},
          {value:'W', text:'Corrientes'},
          {value:'E', text:'Entre Ríos'},
          {value:'P', text:'Formosa'},
          {value:'Y', text:'Jujuy'},
          {value:'L', text:'La Pampa'},
          {value:'F', text:'La Rioja'},
          {value:'M', text:'Mendoza'},
          {value:'N', text:'Misiones'},
          {value:'Q', text:'Neuquén'},
          {value:'R', text:'Rio Negro'},
          {value:'A', text:'Salta'},
          {value:'J', text:'San Juan'},
          {value:'D', text:'San Luis'},
          {value:'Z', text:'Santa Cruz'},
          {value:'S', text:'Santa Fe'},
          {value:'G', text:'Santiago del Estero'},
          {value:'V', text:'Tierra del Fuego'},
          {value:'T', text:'Tucumán'},
        ],
        referencias:[
          {value:1,text:"Google"},
          {value:2,text:"E-mail"},
          {value:3,text:"Redes Sociales"},
          {value:4,text:"Otro"}
        ],
        tiposUsr:[
          {value:1,text:"Comprador"},
          {value:2,text:"Proveedor"},
          {value:3,text:"Ambos"}
        ],

        snackbar:{open:false,color:"",class:"",text:[]}
      }
    },
    created: function () {

     // console.log("editedIndex --> ",  this.editedIndex)
      //console.log("editedItem --> ",  this.editedItem)
      
      this.initialize()


    },
    mounted() {
      /*
      this.$nextTick(function() {
        window.addEventListener('beforeunload', this.closeWindow)
      })
      //window.removeEventListener("beforeunload",functionToRun);
      */
    },
    destroyed: function (){
      //window.removeEventListener('beforeunload', this.closeWindow)
    },
    beforeDestroy: function () {
      //console.log("beforeDestroy")
      //this.closeWindow()
    },
    methods: {
      async initialize(){
        /* INI Carga categories */
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`${this.ROOT_API}categorias`, opt);

        if (response.ok){
          let r=await response.json()
          this.categories=r.map(item => {
            return {
              categoriaID:item.id,
              categoria:(item.categoria).toUpperCase() ,
            }
          })
        }
        /* FIN Carga categories */

        /* INI REFERENCIAS */
        let params=`/?_filters=${JSON.stringify({status:undefined})}&_orders=${JSON.stringify([{field:'order',dir:'asc'},{field:'referencia',dir:'asc'}])}`
        response = await fetch(`${this.ROOT_API}referencias${params}`, opt)
        if (response.ok){
          let r=await response.json()
          this.referencias=r.map(item => { return { value:item.id, text:(item.referencia).toUpperCase() } })

        }
        /* FIN REFERENCIAS */

        if (this.editedIndex!=-1){
          //cargamos items
          let TEmpresa_Otro=""

          this.frm={
            nombre:this.editedItem.nombre || "",
            apellido:this.editedItem.apellido || "",
            email:this.editedItem.email || "",
            celular:this.editedItem.celular || "",
            tipoUsr:this.editedItem.tusrID==0 ? {}: {value:this.editedItem.tusrID,text:this.editedItem.tusuario},
            referencia:this.editedItem.referenciaID==0?null:{text:this.editedItem.referencia,value:parseInt(this.editedItem.referenciaID)},
            
            razonSoc:this.editedItem.razonSoc || "",
            tel:this.editedItem.telefono || "",
            dir:this.editedItem.direccion || "",
            localidad:this.editedItem.localidad || "",
            provincia:this.editedItem.provinciaID==0?null:{text:this.editedItem.provincia,value:this.editedItem.provinciaID},

            cp:this.editedItem.cp || "",
         
            tEmpresa:this.editedItem.tipoEmp.map( function (i) {
              if (i.tempresaID==6) {TEmpresa_Otro=i.obs}
              return {text:i.tempresa,value:i.tempresaID,id:i.id}
            }),
            TEmpresa_Otro,

            categories:this.editedItem.categorias.map( i => {
              return {
                id:i.id,
                categoriaID:i.categoriaID,
                categoria:i.categoria,
                subCategoriaID:i.subcategoriaID,
                subCategoria:i.subcategoriaID==0?'(cualquier subCategoría)':i.subcategoria
              }
            }),


            keys:this.editedItem.keys.map( function (i) {
              return i.palabra
            }),
            completo: 1
          }
        }


      },

      addCategories (){
        if (this.categorie){
          let def={subCategoriaID:0,subCategoria:"(cualquier subCategoría)"}

          let item={...this.categorie,...def}
          
          //console.log(this.subCategorie)
          
          if (this.subCategorie.subCategoria){
            //console.log("sub-->",this.subCategorie)
            item={...this.categorie,...this.subCategorie}

            //
            let idx=this.subCategories.indexOf(this.subCategorie)
            if (idx!=-1){
              this.subCategories[idx].disabled=true
            }

          } else {
            //console.log("SIN SUBCATEGORIA....")
            //Debemos buscar el objeto en this.categories
            let idx=this.categories.indexOf(this.categorie)
            if (idx!=-1){
              this.categories[idx].disabled=true
            }

          }

          //console.log(item)
          this.frm.categories.push(item)  

          this.categorie={}
          
          this.subCategories=[]
          this.subCategorie={}
        }
        
      },
      removeCategories (item,idx) {
          //console.log(item)
          if (item.subCategoriaID==0){
            //console.log("SIN SUBCATEGORIA....")

            //Debemos buscar el objeto en this.categories
            
            let idx = this.categories.map(e => e.categoriaID).indexOf(item.categoriaID)
            //console.log("idx-->",idx)
            //console.log("this.categories[idx]-->",this.categories[idx])
            if (idx!=-1){
              this.categories[idx].disabled=false
            }

          }
      
          this.frm.categories.splice(idx,1)

          this.categorie={}
          
          this.subCategories=[]
          this.subCategorie={}
      },

      addKeys (){
        ///console.log("key-->",this.txtKey)
        this.frm.keys.push(this.txtKey)
        //console.log(this.frm.keys)
        this.txtKey=""
      },
      removeKeys (item,idx){
        this.frm.keys.splice(idx,1)
      },

      async loadSubCategories (){
        let opt={
            method: 'GET', 
            mode: 'cors'
          }
        let response = await fetch(`https://api.t-cotizo.com/subcategorias?categoriaID=${this.categorie.categoriaID}`, opt);

        if (response.ok){
          let r=await response.json()
          this.subCategories=r.map(item => {

            let found = this.frm.categories.find(element => element.subCategoriaID == item.id)
            //console.log("found --> ", item.id, found)
            return {
              subCategoriaID:item.id,
              subCategoria:(item.subcategoria).toUpperCase(),
              disabled:!!found

            }
          })
        }
      },

      async submit () {

        //console.log(this.$v.frm.$invalid)

        this.flgSave=true

        if (this.$v.frm.$invalid){
          this.tab=0
          this.$v.frm.$touch()
          this.flgSave=false
        }  
        else {
          if (this.frm.tipoUsr.value>1 ) {
            this.errors=true
            if (this.categoriesErrors.length>0 ||  this.keysErrors.length>0 ) {

              //console.log("categoriesErrors.len",this.categoriesErrors.length)
              //console.log("keysErrors.len",this.keysErrors.length)
              this.tab=1
              this.flgSave=false
            }
          
          }
        }

        if (this.flgSave){
          console.log("enviamos...")

          let response

          this.frm.completo=1

          //INI
          let opt={
            mode: 'cors',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json'
            },  
            body: JSON.stringify(this.frm),
          }
 
          if (this.editedIndex==-1){
            opt.method= 'POST' 

            response = await fetch(`https://api.t-cotizo.com/usuarios/pre-inscripcion`, opt)
          }
          else {
            opt.method= 'PUT' 
            response = await fetch(`https://api.t-cotizo.com/cms/usuarios/${this.editedItem.id}`, opt)
          }

          this.flgSave=false
          this.$emit("reload")
          this.$emit("close") 
            
        }
      }
    },
    watch: {
      'categorie' : function (val) {

        console.log("val --> ", val)
        if (val && val!=undefined){
          console.log("buscamos subCategorias")
          this.loadSubCategories()
        } else {
          console.log("vaciamos subCategorias") 
          this.subCategories=[]
          this.subCategorie={}
        }
      }

    },
    computed: {
      ...mapGetters(['SESSION','ROOT_API']),

      formTitle: function () {
        return this.editedIndex === -1 ? 'Nueva Usuario' : 'Editar Usuario'
      },

      fechaAlta: function () {
        return format(new Date(this.editedItem.fecha_insert), 'dd-MM-yyyy HH:mm:ss.00')
      },

      countCategories: function () {
        return this.frm.categories.length
      },

      countKeys: function () {
        return this.frm.keys.length 
      },

      // INI VALIDACIONES

      txtKeyErrors () {
        let errors=[]
        if(!this.txtKey.length) return errors
        !(!this.frm.keys.find(key => key == this.txtKey)) && errors.push("Palabra clave ya cargada")
        return errors
      },


      emailErrors () {
        const errors = []
        if (!this.$v.frm.email.$dirty) return errors

        !this.$v.frm.email.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.email.email && errors.push('Debe ser un email válido')
        !this.$v.frm.email.maxLength && errors.push('Debe ser un email válido')

        return errors
      },

      nombreErrors () {
        const errors = []
        if (!this.$v.frm.nombre.$dirty) return errors
        !this.$v.frm.nombre.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.nombre.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.nombre.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      apellidoErrors () {
        const errors = []
        if (!this.$v.frm.apellido.$dirty) return errors
        !this.$v.frm.apellido.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.apellido.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.apellido.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      celularErrors (){
        const errors = []
        if (!this.$v.frm.celular.$dirty) return errors
        //!this.$v.frm.celular.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.celular.maxLength && errors.push('Este campo debe tener formato válido')
        //!this.$v.frm.celular.minLength && errors.push('Este campo debe tener formato válido')
        return errors

      },

      tipoUsrErrors () {
        const errors = []
        if (!this.$v.frm.tipoUsr.$dirty) return errors
        !this.$v.frm.tipoUsr.required && errors.push('Debe seleccionar una opción')
        return errors
      },

      referenciaErrors () {
        const errors = []
        if (!this.$v.frm.referencia.$dirty) return errors
        !this.$v.frm.referencia.required && errors.push('Este campo no puede ser vacío')
        return errors
      },


      razonSocErrors () {
        const errors = []
        if (!this.$v.frm.razonSoc.$dirty) return errors
        !this.$v.frm.razonSoc.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.razonSoc.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.razonSoc.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      telErrors () {
        const errors = []
        if (!this.$v.frm.tel.$dirty) return errors
        !this.$v.frm.tel.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.tel.maxLength && errors.push('Este campo debe tener formato válido')
        !this.$v.frm.tel.minLength && errors.push('Este campo debe tener formato válido')
        return errors
      },

      dirErrors () {
        const errors = []
        if (!this.$v.frm.dir.$dirty) return errors
        !this.$v.frm.dir.required && errors.push('Este campo no puede ser vacío')
        !this.$v.frm.dir.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.dir.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        return errors
      },

      localidadErrors () {

        //console.log(e)

        const errors = []
        if (!this.$v.frm.localidad.$dirty) return errors
        !this.$v.frm.localidad.maxLength && errors.push('Este campo debe tener como máximo 50 caracteres')
        !this.$v.frm.localidad.minLength && errors.push('Este campo debe tener como mínimo 3 caracteres')
        !this.$v.frm.localidad.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      provinciaErrors () {

        const errors = []
        if (!this.$v.frm.provincia.$dirty) return errors
        !this.$v.frm.provincia.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      cpErrors () {
        const errors = []
        if (!this.$v.frm.cp.$dirty) return errors
        //!this.$v.frm.cp.numeric && errors.push('Debe ser un CP válido')
        !this.$v.frm.cp.maxLength && errors.push('Este campo debe tener como máximo 10 caracteres')
        !this.$v.frm.cp.minLength && errors.push('Este campo debe tener como mínimo 4 caracteres')
        !this.$v.frm.cp.required && errors.push('Este campo no puede ser vacío')
        return errors
      },

      tEmpresaErrors () {
        const errors = []
        if (!this.$v.frm.tEmpresa.$dirty) return errors
        !this.$v.frm.tEmpresa.required && errors.push('Debe seleccionar una opción')
        return errors
      },

      categoriesErrors () {
        let error=""
        if(this.frm.categories.length==0 && this.errors) error="Debe seleccionar al menos una categoría"
        return error
      },
      keysErrors () {
        let error=""
        if(this.frm.keys.length==0 && this.errors) error="Debe seleccionar al menos una palabra clave"
        return error
      },

      /* 
        nombre:{required},  
        apellido:{required},
        email: {required, email},
        celular:{required},
        tipoUsr:{required},
        referencia:{required},

        razonSoc:{required},
        tel:{required},
        dir:{required},
        localidad:{required},
        provincia:{required},
        cp:{required},
        tEmpresa:{required},
      */


      // FIN VALIDACIONES
    },
  }

</script>

<style lang="scss" scoped>

</style>